export var noticeSelector = function noticeSelector(_ref) {
  var view = _ref.view;
  return view.data && view.data.notice;
};